export default __webpack_public_path__ + "static/Scroll-Image---Commercial-Interior-Demolition-07a3b0f5fe89e7a4f7b13d28ecb6f0f7.jpg";